module.exports = __webpack_public_path__ + "static/img/manual_ja_39.b28f036.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_39.png
// module id = Ohr/
// module chunks = 4